import api from "@/api/v1-jwt/config/api";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import {
  bulkInvoiceUploadEntitySchema,
  BulkInvoiceUploadEntity,
} from "../types";
import { createErrorHandler } from "@/utils/errorHandler";

type BulkInvoiceCreateParams = { userId: string; bulkUploadId: string };

const bulkInvoiceCreate = async ({
  userId,
  bulkUploadId,
}: BulkInvoiceCreateParams): Promise<BulkInvoiceUploadEntity> => {
  const url = `/platform/invoices/${userId}/bulk/${bulkUploadId}`;
  const response = await api.post(url);
  return bulkInvoiceUploadEntitySchema.parse(response.data);
};

export const bulkUploadBulkCreate = {
  createOptions: (
    options?: UseMutationOptions<
      BulkInvoiceUploadEntity,
      Error,
      BulkInvoiceCreateParams
    >
  ) => {
    const defaultOptions: UseMutationOptions<
      BulkInvoiceUploadEntity,
      Error,
      BulkInvoiceCreateParams
    > = {
      mutationFn: bulkInvoiceCreate,
      onError: createErrorHandler({
        customHandlers: {
          400: () => "Bulk entity has already been processed",
        },
      }),
    };
    return { ...defaultOptions, ...options };
  },
  useMutation: (
    options?: UseMutationOptions<
      BulkInvoiceUploadEntity,
      Error,
      BulkInvoiceCreateParams
    >
  ) => {
    const mutationOptions = bulkUploadBulkCreate.createOptions(options);
    return useMutation<BulkInvoiceUploadEntity, Error, BulkInvoiceCreateParams>(
      mutationOptions
    );
  },
};
